module.exports = __webpack_public_path__ + "static/media/vip-provider-ci.71218a1e.png";